import React from 'react';
interface SectionLabelProps {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
}
export function SectionLabel({
  children,
  tone = 'dark'
}: SectionLabelProps) {
  return <div className="flex items-center gap-4" data-id="element-186" data-mp="2yesxcpys4ef4">
      <span className="h-px w-10 bg-gold" data-id="element-187" data-mp="2yg41iqw4zo6r" />
      <span className={`text-[11px] font-semibold uppercase tracking-overline ${tone === 'dark' ? 'text-gold-deep' : 'text-gold-light'}`} data-id="element-188" data-mp="33dx83l1cqk7k">
        {children}
      </span>
    </div>;
}